export var zetaDocs = {
  name: 'zeta',
  category: 'Special',
  syntax: ['zeta(s)'],
  description: 'Compute the Riemann Zeta Function using an infinite series and Riemanns Functional Equation for the entire complex plane',
  examples: ['zeta(0.2)', 'zeta(-0.5)', 'zeta(4)'],
  seealso: []
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/expression/embeddedDocs/function/special/zeta.js
// module id = 3j9p
// module chunks = 3